import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { getFaqList } from "../../../service/cms/cms";
import { useTranslation } from "react-i18next";
const InvoiceFaq = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  const [faqList, setFaqList] = useState([]);
  const _GET_FAQ_LIST = async () => {
    getFaqList("INVOICE")
      .then((res) => {
        setFaqList(res?.data?.data);
        console.log(res.data.data, "resData");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    _GET_FAQ_LIST();
  }, []);

  const items = [
    {
      title: "What is React?",
      content: "React is a JavaScript library for building user interfaces.",
    },
    {
      title: "Why use React?",
      content:
        "React allows developers to create large web applications that can change data, without reloading the page. The main purpose of React is to be fast, scalable, and simple. It works only on user interfaces in the application.",
    },
    {
      title: "How to use React?",
      content:
        "You can use React by installing it via npm and then creating components to build your application.",
    },
  ];

  const onTitleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain invoiceFaqBg">
        <Leftpanel breadcm="Invoice" />
        <div className="dbRight">
          <Header link="#" breadcm="" title={t("Faq's")} description="" />
          <div className="commonBase">
            <div className="aboutBase">
              {/* <img src={aboutbnr} alt=''/> */}

              <div className="accordion faqAccordion">
                {faqList.map((item, index) => (
                  <div key={index} className="accordion-item">
                    <div
                      className={`accordion-title ${
                        index === activeIndex ? "active" : ""
                      }`}
                      onClick={() => onTitleClick(index)}
                    >
                      {item?.question}
                    </div>
                    {index === activeIndex && (
                      <div className="accordion-content">
                        <p>{item?.answer}</p>
                        {item?.faqImg && (
                          <img
                            src={`https://nodeserver.mydevfactory.com:8000/uploads/customer/${item?.faqImg}`}
                            alt=""
                            width={50}
                            height={50}
                          />
                        )}
                        {item?.faqVideo && (
                          <video width="320" height="240" controls>
                            <source
                              src={`https://nodeserver.mydevfactory.com:8000/uploads/customer/${item?.faqVideo}`}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFaq;
